import { useParams, Navigate } from 'react-router-dom';

export default function TalentSlugRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/talents/${slug}`} replace />;
}
